import { JSX, StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ConfigurationService } from '../../../services/configuration.service';
import ParticipationOverview from './index';
import NotFoundRedirect from '../Shared/NotFoundRedirect';

const router = createBrowserRouter(
  [
    {
      path: '/:participationId',
      element: <ParticipationOverview />,
    },
    { path: '*', element: <NotFoundRedirect /> },
  ],
  { basename: ConfigurationService.get('paegnaben.participationoverviewpage.basename') }
);

export default function createRouterProvider(): JSX.Element {
  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}

